import SidebarItem from "./SidebarItem";
import { useAuth } from "../../../context/AuthContext";
import "./sidebar.css";
import acu_logo from "../../../assets/images/acumenVelocityLogo.svg";

const getSidebarData = (isAdmin) => [
  {
    title: "",
    childrens: [
      { title: "Overview", icon: "bi-asterisk", path: "/over-view" },
      { title: "Portals", icon: "bi-columns", path: "/portals" },
      { title: "Resources", icon: "bi-border-style", path: "/resources" },
      { title: "Translation Jobs", icon: "bi-list-ul", path: "/translationJobs" },
      { title: "Users", icon: "bi-person-fill", path: "/users" },
      { title: "Settings", icon: "bi-gear-fill", path: "/settings" },
      ...(isAdmin ? [{ title: "Activity Logs", icon: "bi-journal-text", path: "/system-logs" }] : []),
      { title: "Profile", icon: "bi-person-circle", path: "/profile" },
      { title: "Logout", icon: "bi-box-arrow-right", path: "/logout" },
    ],
  },
];

export default function Sidebar() {
  const { isAdmin } = useAuth();
  const items = getSidebarData(isAdmin);

  return (
    <div className="sidebar d-flex flex-column bg-white border-end">
      <div className="translation d-flex align-items-center border-bottom mt-2">
        <div className="translation d-flex px-2">
          <img src={acu_logo} className="tranlation_logo img-fluid me-2" alt="Logo" />
          <h6 className="m-0 d-none d-md-block text-start">Acumen Translation Hub</h6>
        </div>
      </div>
      <div className="flex-grow-1 px-3">
        {items.map((item, index) => (
          <SidebarItem key={index} item={item} />
        ))}
      </div>
    </div>
  );
}
